module.exports = __webpack_public_path__ + "static/Familiar1-19515b9c48aa3bd308fc41f51a5c91c9.jpeg";